import {countries} from '../helpers/countries';
import {applicantFields, peCoverageField, studentNumberFields} from '../helpers/fields';

import * as fieldGroups from '../helpers/fieldGroups';

const clientName = 'goosesquareone';
const org = 'ingle';

export function expandedGroups() {
  return [
    fieldGroups.policyGroup(clientName, 'Referrer'),
    fieldGroups.primaryApplicantDetailsGroup(clientName),
    fieldGroups.emailNotificationGroup(),
    fieldGroups.feeRefundGroup(),
    fieldGroups.contactDetailsGroup(clientName),
    fieldGroups.dependentDetailsGroup(clientName),
    fieldGroups.coverageDetailsGroup(clientName),
    fieldGroups.extensionGroup(),
    fieldGroups.beneficiaryGroup(),
    fieldGroups.paymentGroup(clientName),
    fieldGroups.fulfillmentGroup(),
    fieldGroups.renewalGroup(),
    fieldGroups.historyGroup(),
    fieldGroups.notesGroup(),
  ];
}

export function fields() {
  return {
    primary_applicant_fields: [
      ...peCoverageField('0', org),
    ],
    dependent_fields: [
      ...applicantFields('*', [
        { value: 'dependent', text: 'Dependent' },
        { value: 'travelling companion', text: 'Travelling Companion' },
        { value: 'spouse', text: 'Spouse' }
      ]),
      ...peCoverageField('*', org),
    ],
  	coverage_fields: [
      {
        key_path: ['applicant', '*', 'policy_number'],
        as: 'Policy Document',
        type: 'button',
        action: 'policy_document',
        icon: '',
        show_only_when: 'view',
        is_static_by_default: true,
      },
      {
        key_path: ['application', 'additional_data', 'country_of_origin'],
        as: 'Country of Origin',
        type: 'dropdown',
        options: countries().filter(country => (country.value !== 'CA'))
      },
      {
        key_path: ['application', 'additional_data', 'in_canada'],
        as: 'Are applicants currently in Canada?',
        type: 'radio',
        options: [
          {value: 'no', text: 'No'},
          {value: 'yes', text: 'Yes'}
        ]
      },
      {
        key_path: ['application', 'additional_data', 'super_visa'],
        as: 'Are applicants travelling to Canada on a Super Visa?',
        type: 'radio',
        options: [
          {value: 'no', text: 'No'},
          {value: 'yes', text: 'Yes'}
        ]
      },
      {
        key_path: ['application', 'additional_data', 'deductible'],
        as: 'Deductible',
        type: 'dropdown',
        options: [
          {value: 0, text: '$0.00 CAD'},
          {value: 100, text: '$100.00 CAD'},
          {value: 250, text: '$250.00 CAD'},
          {value: 500, text: '$500.00 CAD'},
          {value: 1000, text: '$1,000.00 CAD'},
          {value: 3000, text: '$3,000.00 CAD'},
          {value: 5000, text: '$5,000.00 CAD'},
          {value: 10000, text: '$10,000.00 CAD'},
          {value: 25000, text: '$25,000.00 CAD'}
        ]
      }
    ]
  }
}


// WEBPACK FOOTER //
// ./src/clients/goosesquareone.js